//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "swiper/css/swiper.css";
import ProductCard from "~/components/product/ProductCard.vue";
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin"
import {
  Swiper,
  SwiperSlide
} from "vue-awesome-swiper";
import { getUuidToken } from "~/store/mindbox";
import { Product } from '~/node_modules/sitisjs/dist/internal/sections/products/models/Product';

export default BaseCmsBlock.extend({
  name: "MindboxPopularBlock",

  data: function () {
    return {
      products: [],
      isLoadingProducts: true,

      swiperOptions: {
        spaceBetween: 12,
        slidesPerView: 1.6,
        slidesPerGroup: 1,

        breakpoints: {
          640: {
            slidesPerView: 2.2
          },
          1000: {
            pagination: null,
            slidesPerView: 3.2,
          },
          1200: {
            spaceBetween: 24,
            slidesPerView: 5,
            slidesPerGroup: 1,
          },
        },
        navigation: {
          prevEl: '.mindbox-personal-block__navigation.--prev',
          nextEl: '.mindbox-personal-block__navigation.--next'
        },
        pagination: {
          el: ".mindbox-personal-block__pagination",
          type: 'bullets'
        },
      }
    }
  },

  computed: {
    isShowContent: function () {
      return Boolean(this.isLoadingProducts || this.products.length > 0)
    }
  },

  components: {
    Swiper,
    SwiperSlide,
    ProductCard
  },

  mounted: async function () {
    await this.getProducts();
  },

  methods: {
    getProducts: async function () {
      const limit = this.values?.limit || 5;
      const device_uuid = await getUuidToken(this.$cookies);
      const response = await this.$api.agent.transport.post('/mindbox/products/get-personal-products', {
        limit: limit,
        device_uuid: device_uuid,
      })
        .then((res) => {
          return res?.data || []
        })
        .catch((err) => []);

      this.products = [...response].map((t) => new Product(t));
      this.isLoadingProducts = false;
    },
  }
});
